import React, { useState, useCallback, useRef, useEffect } from "react";
import {
  GoogleMap,
  Marker,
  MarkerF,
  DirectionsRenderer,
  useJsApiLoader,
  InfoWindowF,
} from "@react-google-maps/api";
import store_open from "../../Assets/images/store_open.png";
import deliveryman_online_with_orders from "../../Assets/images/deliveryman_online_with_orders.png";
import { FaHouseUser, FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

const containerStyle = {
  width: "100%",
  height: "92vh",
};

const customerLocation = {
  lat: 22.0890847442456, // Example customer coordinates
  lng: 82.1406660628033,
};

const deliverymanLocation = {
  lat: 22.0790847442456, // Example deliveryman coordinates
  lng: 82.1406660628033,
};

const libraries = ["places", "drawing"];

function GoogleMapsView(storeLocations) {
  console.log(
    "storeCoordinates from gooleMap:",
    storeLocations?.storeLocations
  );

  const formattedLocations =
    storeLocations &&
    storeLocations?.storeLocations?.map((coordinates) => ({
      lat: coordinates?.location?.coordinates[1],
      lng: coordinates?.location?.coordinates[0],
    }));

  const center = formattedLocations
    ? formattedLocations.reduce(
        (acc, loc, _, array) => {
          acc.lat += loc.lat / array.length;
          acc.lng += loc.lng / array.length;
          return acc;
        },
        { lat: 0, lng: 0 }
      )
    : { lat: 22.069084, lng: 82.140666 };

  console.log("Formatted Locations:", formattedLocations);
  console.log("Center:", center);

  console.log("formattedLocations:", formattedLocations);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyBu92f4nKc9t8J0Aa17oVOUFlwn659OEGU",
    libraries,
  });

  const [map, setMap] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [activeMarker, setActiveMarker] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);

  const handleMouseOver = (index) => {
    setActiveMarker(index);
  };

  const handleMouseOut = () => {
    setActiveMarker(null);
  };

  const mapRef = useRef(null);

  // const onLoad = useCallback((map) => {
  //   const bounds = new window.google.maps.LatLngBounds();
  //   bounds.extend(center);
  //   bounds.extend(customerLocation);
  //   bounds.extend(deliverymanLocation);
  //   map.fitBounds(bounds);
  //   setMap(map);
  //   mapRef.current = map;
  // },
  //  []);
  const onLoad = useCallback((map) => {
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(center);
    bounds.extend(customerLocation);
    bounds.extend(deliverymanLocation);
    map.fitBounds(bounds);
    setMap(map);
    mapRef.current = map;

    // Add a custom button for getting current location
    const locationButtonDiv = document.createElement("div");
    locationButtonDiv.className = "custom-location-button";
    locationButtonDiv.title = "Get Current Location";
    // locationButtonDiv.addEventListener("click", handleGetLocation);
    locationButtonDiv.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; cursor: pointer; background: white; border-radius: 8px; padding: 8px;">
      <span style="font-size: 24px; color: blue;">📍</span>
    </div>`;
    map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(
      locationButtonDiv
    );

    locationButtonDiv.addEventListener("click", () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            // alert(JSON.stringify(userLocation));
            setCurrentLocation(userLocation);
            map.panTo(userLocation);
            map.setZoom(14);
          },
          (error) => {
            console.error("Error getting current location:", error);
          }
        );
      }
    });

  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  useEffect(() => {
    if (isLoaded && map) {
      const directionsService = new window.google.maps.DirectionsService();

      directionsService.route(
        {
          origin: center,
          destination: customerLocation,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setDirectionsResponse(result);
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    }
  }, [isLoaded, map]);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={12}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {/* current location maker  */}
      {currentLocation && (
          <Marker
            position={currentLocation}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillColor: "blue",
              fillOpacity: 1,
              strokeWeight: 2,
              strokeColor: "white",
            }}
            label={{
              text: "You",
              className: "current-location-label",
            }}
          />
        )}

      {/* Store Marker */}
      {storeLocations &&
        storeLocations?.storeLocations?.map((coordinates, index) => (
          <>
            <MarkerF
              key={index} // Add a unique key for each element
              position={{
                lat: coordinates?.location?.coordinates[1],
                lng: coordinates?.location?.coordinates[0],
              }}
              icon={{
                url: "https://i.pinimg.com/736x/b7/da/4f/b7da4f92fb9297558ceffd5d189564e0.jpg",
                scaledSize: new window.google.maps.Size(30, 30), // Resize to 50x50 pixels
              }}
              onMouseOver={() => handleMouseOver(index)}
              onMouseOut={handleMouseOut}
            />
            {activeMarker === index && (
              <InfoWindowF
                position={{
                  lat: coordinates?.location?.coordinates[1],
                  lng: coordinates?.location?.coordinates[0],
                }}
                onCloseClick={() => setActiveMarker(null)}
              >
                <div style={{ padding: "2px" }} className="">
                  <h4>
                    {coordinates?.first_name} {coordinates?.last_name}
                  </h4>

                  <div className="flex">
                    {Array.from({ length: 5 }, (_, i) => {
                      const rating = coordinates?.average_rating;
                      if (i < Math.floor(rating)) {
                        return <FaStar key={i} color="gold" size={12} />;
                      } else if (i < rating) {
                        return <FaStarHalfAlt key={i} color="gold" size={12} />;
                      } else {
                        return <FaRegStar key={i} color="gray" size={12} />;
                      }
                    })}
                  </div>

                  <p className="mb-1">{coordinates?.phone_number}</p>
                  <p className="w-[150px]">
                    "{coordinates?.delivery_business?.description}"
                  </p>
                </div>
              </InfoWindowF>
            )}
          </>
        ))}

      {/* <Marker 
        position={customerLocation} 
        icon={{url:<FaHouseUser />}}
        // label="Customer"
        
      />

      
      <Marker 
        position={deliverymanLocation} 
        icon={{
          url: deliveryman_online_with_orders, 
          scaledSize: new window.google.maps.Size(50, 50), 
        }}
        // label="Deliveryman" 
        /> */}

      {/* {directionsResponse && <DirectionsRenderer directions={directionsResponse} />} */}
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(GoogleMapsView);
